import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { School } from '@/types/school';

export const getSchools = async (loginUserEmail?: string): Promise<ApiResult<School[]>> => {
  const { status, result } = await callApi<School[]>(
    `schools`,
    'GET',
    undefined,
    undefined,
    loginUserEmail,
    undefined,
    true
  );
  return { status, result };
};
